import React, { FC } from "react";
import map from "lodash/map";
import Img from "@/components/img";
import { CategoryItem } from "./types";

const GroupCategories: FC<{
  title: string;
  dataList: CategoryItem[];
  handleClick: (item: CategoryItem) => void;
}> = ({ title, dataList, handleClick }) => (
  <div className="group_by_categories_wrapper">
    {title && <h3>{title}</h3>}
    <ul className="categories_list">
      {map(dataList, item => (
        <li key={item.uid} onClick={() => handleClick(item)}>
          <span className="image_wrapper">
            <Img
              src={item.imageUrl || ""}
              alt={item.en_subTitle ?? item.subTitle}
            />
          </span>
          <span className="item_sub_title">{item.subTitle}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default GroupCategories;
